import {

    List,

} from "semantic-ui-react";

const StateLinkList = (states) => {
    let stateList = [];
    if (states) {
        let keys = Object.keys(states);
        keys.sort();
    }
    return stateList;
}

export default StateLinkList